import { createRouter, createWebHistory } from 'vue-router';
import { LikeShopGalleryType } from '@/apis/likeshop';
import { likeshopCopy } from '@/config/messages';
import ErrorMessage from '@/components/ErrorMessage.vue';
import Home from '@/pages/instagram/Home.vue';
import TiktokHome from '@/pages/tiktok/Home.vue';

const routes = [
  {
    path: '/:instagramHandle',
    name: 'Home',
    component: Home,
    meta: {
      title: 'LikeShop',
      galleryType: LikeShopGalleryType.INSTAGRAM,
    },
  },
  {
    path: '/:instagramHandle/media/:galleryMediaId',
    name: 'LikeShopMediaPopup',
    component: Home,
    meta: {
      title: 'LikeShop',
      galleryType: LikeShopGalleryType.INSTAGRAM,
    },
  },
  {
    path: '/preview/:instagramHandle',
    name: 'Preview',
    component: Home,
    meta: {
      isPreview: true,
      galleryType: LikeShopGalleryType.INSTAGRAM,
    },
  },
  {
    path: '/t/:tiktokHandle',
    name: 'TiktokHome',
    component: TiktokHome,
    meta: {
      title: 'TikTok LikeShop',
      galleryType: LikeShopGalleryType.TIKTOK,
    },
  },
  {
    path: '/t/:tiktokHandle/media/:galleryMediaId',
    name: 'TiktokLikeShopMediaPopup',
    component: TiktokHome,
    meta: {
      title: 'TikTok LikeShop',
      galleryType: LikeShopGalleryType.TIKTOK,
    },
  },
  {
    path: '/t/preview/:tiktokHandle',
    name: 'TikTokLikeShopPreview',
    component: TiktokHome,
    meta: {
      isPreview: true,
      galleryType: LikeShopGalleryType.TIKTOK,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: ErrorMessage,
    props: {
      message: likeshopCopy.notFound,
    },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
